export default __webpack_public_path__ + "static/club-gallery-10-236ed267aecee4e22474113fcc4f57d6.webp";